import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getCustomerList(params) {
  return request({
    url: '/GetCustomerList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000001,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Status: params.Status,
        KeyWord: params.KeyWord,
        StartDate: params.StartDate,
        EndDate: params.EndDate
      }
    }
  })
}

export function addCustomer(params) {
  return request({
    url: '/AddCustomer',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000002,
      MessageID: btcguid(),
      Data: {
        CompanyName: params.CompanyName,
        CustomerPicture: params.CustomerPicture,
        CustomerRepresentative: params.CustomerRepresentative
      }
    }
  })
}

export function uploadCustomerFile(params) {
  const formData = new FormData()
  formData.append('MessageType', 19000003)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  formData.append('UserID', params.UserID)
  return request({
    url: '/UploadCustomerFile',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function updateCustomer(params) {
  return request({
    url: '/UpdateCustomer',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000010,
      MessageID: btcguid(),
      Data: {
        CustomerID: params.CustomerID,
        CompanyName: params.CompanyName,
        CustomerPicture: params.CustomerPicture,
        CustomerRepresentative: params.CustomerRepresentative
      }
    }
  })
}

export function approvalCustomer(params) {
  return request({
    url: '/ApprovalCustomer',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000006,
      MessageID: btcguid(),
      Data: {
        CustomerID: params.CustomerID,
        Status: params.Status,
        RejectNote: params.RejectNote
      }
    }
  })
}

// ----------------------------------------------审批板块--------------------------------------------------------

export function getContractList(params) {
  return request({
    url: '/GetContractList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000004,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Status: params.Status,
        KeyWord: params.KeyWord,
        StartDate: params.StartDate,
        EndDate: params.EndDate
      }
    }
  })
}

export function updateContractNote(params) {
  return request({
    url: '/UpdateContractNote',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000005,
      MessageID: btcguid(),
      Data: {
        ContractID: params.ContractID,
        Note: params.Note
      }
    }
  })
}

export function getBuyerOrSeller(params) {
  return request({
    url: '/GetBuyerOrSeller',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000007,
      MessageID: btcguid(),
      Data: {}
    }
  })
}

export function uploadContractFile(params) {
  const formData = new FormData()
  formData.append('MessageType', 19000008)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  formData.append('UserID', params.UserID)
  formData.append('FolderName', params.FolderName)
  return request({
    url: '/UploadContractFile',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function addContract(params) {
  return request({
    url: '/AddContract',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000009,
      MessageID: btcguid(),
      Data: {
        Buyer: params.Buyer,
        Seller: params.Seller,
        ContractNo: params.ContractNo,
        ContractPicture: params.ContractPicture,
        OperatorName: params.OperatorName
      }
    }
  })
}

export function contractOperation(params) {
  return request({
    url: '/ContractOperation',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000010,
      MessageID: btcguid(),
      Data: {
        ContractID: params.ContractID,
        OperatorName: params.OperatorName,
        Role: params.Role,
        Type: params.Type,
        ContractPicture: params.ContractPicture,
        PickUpTime: params.PickUpTime,
        PickUpLocation: params.PickUpLocation,
        LogisticsCompany: params.LogisticsCompany,
        Plate: params.Plate,
        DriverName: params.DriverName,
        DriverPhont: params.DriverPhont,
        DriverIDCard: params.DriverIDCard,
        isReject: params.isReject,
        RejectNote: params.RejectNote
      }
    }
  })
}

export function depositTailInvoice(params) {
  return request({
    url: '/DepositTailInvoice',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000011,
      MessageID: btcguid(),
      Data: {
        isPhase: params.isPhase,
        ContractID: params.ContractID,
        OperatorName: params.OperatorName,
        Role: params.Role,
        Type: params.Type,
        ContractPicture: params.ContractPicture
      }
    }
  })
}

export function updateContractOperation(params) {
  return request({
    url: '/UpdateContractOperation',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000012,
      MessageID: btcguid(),
      Data: {
        ContractID: params.ContractID,
        OperatorName: params.OperatorName,
        Type: params.Type,
        ContractPicture: params.ContractPicture,
        Buyer: params.Buyer,
        Seller: params.Seller,
        ContractNo: params.ContractNo
      }
    }
  })
}

export function updateLogistics(params) {
  return request({
    url: '/UpdateLogistics',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000013,
      MessageID: btcguid(),
      Data: {
        ContractID: params.ContractID,
        PickUpTime: params.PickUpTime,
        PickUpLocation: params.PickUpLocation,
        LogisticsCompany: params.LogisticsCompany,
        Plate: params.Plate,
        DriverName: params.DriverName,
        DriverPhont: params.DriverPhont,
        DriverIDCard: params.DriverIDCard
      }
    }
  })
}

export function addContractDocument(params) {
  return request({
    url: '/AddContractDocument',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000014,
      MessageID: btcguid(),
      Data: {
        ContractID: params.ContractID,
        OperatorName: params.OperatorName,
        Type: params.Type,
        ContractDocument: params.ContractDocument
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/contract.js